<gp-message *ngIf="!report?.filters?.length" text="REPORTS.no_filters_selected" type="info"></gp-message>

<div class="streamline" *ngIf="report?.filters?.length">
  <ng-container *ngFor="let item of (report?.filters || []); let i = index; let last=last;">
    <div class="sl-item"
         [class.active]="item.filter?.length"
         [draggable]="isDragEnabled"
         (dragstart)="dragStart(item)"
         (dragenter)="dragEnter(i)"
         (dragend)="dragEnd()"
         [ngStyle]="dragFilter?.field === item.field ? {border: '1px dotted #9B9B9B'} : {}">
      <div class="sl-content">
        <gp-filter-item style="width: 100%"
                        [report]="report"
                        [config]="item"
                        [toggleable]="toggleable"
                        [draggable]="sortable"
                        [attr.test-id]="'gp-filter-item' | gpTestId: 'report-filter': item.field"
                        [enabledFields]="enabledFields"
                        [isOpen]="isOpen"
                        (removeFilterItem)="removeFilter($event)"
                        (dragHandleActive)="setDragEnabled($event)"
                        (filterItemLoaded)="onFilterItemLoaded()">
        </gp-filter-item>
      </div>
      <label class="text-muted light operator " *ngIf="showAndOperatorText && !last">{{ 'MDU.AND' | translate }}</label>
    </div>
  </ng-container>

</div>
